import Carousel from "./component/Carousel";
import DropdownMenu from "./component/DropdownMenu";
import Footer from "./component/Footer";
import LogoContent from "./component/LogoContent";
import Navbar from "./component/Navbar";
import Home from "./pages/home";

import { bannerSide } from "./inc/Datamenu_inc";
import { useState } from "react";
import PageTransition from "./component/PageTransition";

export default function App() {
  const [showContent, setShowContent] = useState(false);

  return (
    <>
      <PageTransition showContent={showContent} setShowContent={setShowContent}>
        ศูนย์การเรียนรู้และส่งเสริมสุขภาพทางสัตวแพทย์ภาคเหนือ
      </PageTransition>
      {showContent && (
        <div className="relative ">
          <Navbar />
          <Carousel BannerImg={bannerSide} />
          <div className="flex flex-col gap-y-5">
            <DropdownMenu />
            <LogoContent />
            <div className="flex flex-col container mx-auto max-w-5xl lg:px-0 gap-y-5 px-5">
              <Home />
            </div>
            <Footer />
          </div>
        </div>
      )}
    </>
  );
}
